// extracted by mini-css-extract-plugin
export default {"partnersModal":"styles_partnersModal__fooz3","modalContent":"styles_modalContent__cI9sw"};